import React from "react";
import clx from "clsx";
import PropTypes from "prop-types";
import { CalendarIcon } from "@heroicons/react/outline";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import CustomDateComponent from "@hassanmojab/react-modern-calendar-datepicker";

function InputDate({
  error = null,
  disabled = null,
  size = "base",
  value = null,
  onChange = null,
  onBlur = null,
  placeholder = null,
  name = null,
  ...props
}) {
  let classNames = clx(
    `appearance-none transition-all duration-300 ease-in-out rounded  px-3 text-gray-800  leading-tight outline-none  w-full  focus:border-2  focus:border-blue-500`,
    {
      "opacity-75 cursor-not-allowed": disabled,
      "border border-red-400": error,
      "border border-gray-300": !error,
      "h-8 text-xs": size === "sm",
      "h-10 text-sm": size == "base",
      "h-12 text-base": size == "lg",
    }
  );

  const renderCustomInput = ({ ref }) => (
    <div className="relative z-0">
      <input
        name={name}
        type="text"
        disabled={disabled}
        placeholder={placeholder}
        readOnly
        ref={ref}
        onBlur={onBlur}
        className={classNames}
        value={displayDate(value)}
      />

      <div className="absolute text-gray-500 w-10  right-0 top-0   flex justify-center items-center h-full">
        <CalendarIcon className="w-5 h-5 text-gray-300"></CalendarIcon>
      </div>
    </div>
  );

  function parseValue(ISODate) {
    if (!ISODate) {
      return null;
    }
    let originalDate = parseISO(ISODate);

    return {
      year: originalDate.getFullYear(),
      month: originalDate.getMonth() + 1,
      day: originalDate.getDate(),
    };
  }

  function displayDate(ISODate) {
    if (!ISODate) {
      return "";
    }
    let instanceDate = parseISO(ISODate);

    return format(instanceDate, "dd-MM-yyyy");
  }

  return (
    <div>
      <CustomDateComponent
        value={parseValue(value)}
        colorPrimary="#0EA5E9"
        onChange={(val) => {
          let instanceDate = new Date(val.year, val.month - 1, val.day);
          let ISODate = format(instanceDate, "yyyy-MM-dd");
          onChange(ISODate);
        }}
        renderInput={renderCustomInput}
        slideAnimationDuration="0.3s"
        inputPlaceholder="Select a day"
        shouldHighlightWeekends
        calendarClassName="datepicker-calendar"
        inputClassName="datepicker-input"
        {...props}
      />
    </div>
  );
}

InputDate.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(["sm", "base", "lg"]),
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  value: PropTypes.any,
};

export default InputDate;
